import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/enterprise-apps/enterprise-apps/apps/pfdn/src/app/HomeClient.tsx");
